import React, { useState, useEffect, useRef } from "react";
import utils from "../../Utils";
import ViewClinicProfileCard from "../../Widgets/viewClinicProfileCard/viewClinicProfileCard.js";
import "./profile.css";
import authService from "../../Services/authService";
import clinicService from "../../Services/clinicService";
import strings from "../../Utils/strings";
import EditProfileDropdown from "../editProfile/editProfileDropdown";
import ViewClinicProfileDetails from "./viewClinicprofileDetails";
import { Calendar } from "react-multi-date-picker";
import toast from "react-hot-toast";
import moment from "moment";
import AppDialog from "../../Widgets/appDialog/appDialog.jsx";
import Widgets from "../../Widgets";
import constants from "../../Utils/constants";
import ClinicConfiguration from "../manageClinic/clinicConfiguration";
import ClinicProfile from "../manageClinic/clinicProfile";
import OffCanvas from "../common/offCanvas";
import { t } from "../../Utils/translate";
import ClinicTiming from "../manageClinic/clinicTiming/clinicTiming";
import Component from "..";

function ViewClinicProfile({ refreshHeader }) {
  const isFetched = useRef(false);
  const today = new Date();
  const tomorrow = today.setDate(today.getDate() + 1);
  const [clinicDetails, setClinicDetails] = useState([]);
  const [image, setImage] = useState("");
  const [popup, setPopup] = useState(false);
  const [dateList, setDateList] = useState([]);
  const [leaveTitle, setLeaveTitle] = useState("");
  const [holidayList, setHolidayList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDoctorLogin, setIsDoctorLogin] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [lastSelectedDate, setLastSelectedDate] = useState(null);
  const [isSetAsWorkingDay, setIsSetAsWorkingDay] = useState(false);
  const [selectedLeaveId, setSelectedLeaveId] = useState("");
  const [editClinicProfile, setEditClinicProfile] = useState(false);
  const [editConfig, setEditConfig] = useState(false);
  const [editClinicTiming, setEditClinicTiming] = useState(false);
  const [randomRefresherNumber, setRandomRefresherNumber] = useState(0)
  const [cancelAppointmentPopUp, setCancelAppointmentPopUp] = useState(false)
  const [leaveDate, setLeaveDate] = useState(null);
  const [leaveReason, setLeaveReason] = useState("");
  useEffect(() => {
    initFun();
  }, []);

  function initFun() {
    setIsDoctorLogin(authService.getIsDoctorLogin());
  }
  useEffect(() => {
    if (popup) {
      getAllLeaves();
    }
  }, [popup]);
  useEffect(() => {
    if (!isFetched.current) {
      getClinicProfile();
      isFetched.current = true;
    }
  }, []);

  const getAllLeaves = async () => {
    try {
      const response = await clinicService.getAllLeaves();
      console.log(response);
      
      if (response && response.status === "success") {
        const formattedLeaves = response.data.leaves.map((leave) => ({
          leaveId: leave._id,
          leaveOf: leave.date, 
          reason: leave.reason,
        }));
        setHolidayList(formattedLeaves);
        console.log(holidayList)
      }
    } catch (error) {
      console.error("Error fetching holiday list:", error);
    }
  };

  const getClinicProfile = async () => {
    try {
      setIsLoading(true);
      let response
      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.docGetClinicProfile();
      } else if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.hospitalProfile();
      }
      setIsLoading(false);
      if (response) {
        setClinicDetails(response.data.hospital);
        setImage(response.clinicDetails.logo);
      }
    } catch { }
  };

  const handleSelectedDateChanges = (dates) => {
    const selectedDate = new Date(dates);
  
    if (!isNaN(selectedDate)) {
      const formattedDate = selectedDate.toISOString().split("T")[0];
      console.log(formattedDate);
      
      setLeaveDate(selectedDate); 
    } else {
      console.error("Invalid date selected");
    }
    setClicked(true)
  };
  

  
  const handleSubmitLeave = async () => {
    if (!leaveReason.trim()) {
      toast.error(t("enterLeaveReason"));
      return; 
    }
    try {
      const body = {
        date: leaveDate,
        reason: leaveReason,
      };

      const response = await clinicService.createHospitalLeave(body);
      if (response.status === 'success') {
        toast.success(t("leaveCreated"));
        setLeaveReason("");
        setLeaveDate(null);
        setPopup(false);
        getAllLeaves();
      } else {
        toast.error(response.data.message);
        console.error("Failed to create leave:", response.data);
      }
    } catch (error) {
      console.error("Error creating leave:", error);
    }
  };

  const handleDeleteLeave = async (leaveId) => {
    try {
      const response = await clinicService.deleteHospitalLeave(leaveId);
      if (response.status === "success") {
        toast.success(t("leaveDel"));
        setPopup(false);
        setTimeout(() => {
          setPopup(true);
          getAllLeaves();
        }, 200); 
      } else {
        toast.error("Failed to delete leave");
      }
    } catch (error) {
      console.error("Error deleting leave:", error);
      toast.error("An error occurred while deleting the leave");
    }
  };
  
  const handleClinicProfileUpdate = (isEditable) => {
    setIsLoading(isEditable);
  };

  const handleClinicConfigurationUpdate = (isEditableConfigure) => {
    setIsLoading(isEditableConfigure);
  };

  const handleEditClinicTimingUpdate = (isEditable) => {
    setRandomRefresherNumber(
      Math.floor(Math.random() * 10)
    );
    setIsLoading(isEditable);
  };

  const filteredHolidayList = holidayList.filter((leave) => {
    const leaveDate = moment(leave.leaveOf, "DD-MM-YYYY");
    return leaveDate.isSameOrAfter(moment(), "day");
  });

  const disableButton = () => {
    let returnValue = false;
    if (leaveTitle !== "" && leaveTitle && leaveTitle.length > 0) {
      returnValue = false;
    } else {
      returnValue = true;
    }
    return returnValue;
  };

  const handleClinicProfileCanvasChanges = () => {
    setEditClinicProfile(false);
  };

  const handleClinicConfigCanvasChanges = () => {
    setEditConfig(false);
  };

  const handleClinicTimingCanvasChanges = () => {
    setEditClinicTiming(false);
  };

  return (
    <>
      {isLoading ? (
        <Widgets.CircularLoader />
      ) : (
        <div className="clinic-profile">

          {cancelAppointmentPopUp ? (
            <AppDialog
              setVisibility={(e) => {
                setCancelAppointmentPopUp(e);
              }}
              widthType={utils.constants.dialogWidthType.small}
              dialogTitle={t("cancelRemoteAppointment")}
              dialogPositiveBtnText={t("ok")}
              dialogPositiveBtnCall={() => {
                setCancelAppointmentPopUp(false);
              }}
              view={
                <Component.WarningPop iconClassName="ri-delete-bin-line" warningMsg={t("cancelAppointment")} />
              }
            />
          ) : null}
          {popup ? (
            <AppDialog
    setVisibility={(e) => {
        setClicked(false);
        setPopup(e);
    }}
    dialogTitle={t("labelManageLeave")}
    dialogNegativeBtnText={clicked ? t("btnCancel") : null}
    dialogPositiveBtnText={clicked ? t("btnSubmit") : null}
    dialogPositiveBtnCall={handleSubmitLeave}
    disablePositiveBtn={(!leaveReason)} // Disables button if leaveReason is empty
    dialogNegativeBtnCall={() => {
        setPopup(false);
        setClicked(false);
        setLeaveDate(null)
        setLeaveReason("")
    }}
    view={
        <div style={{width:"100%"}}>
                  <Calendar
  fixMainPosition
  value={leaveDate}
  onChange={handleSelectedDateChanges}
  format="DD-MM-YYYY"
  sort
  minDate={tomorrow}
  mapDays={({ date }) => {
    const jsDate = date instanceof Date ? date : date.toDate();
    const isLeaveDate = holidayList.some((leave) =>
      moment(leave.leaveOf, "DD-MM-YYYY").isSame(jsDate, "day")
    );

    if (isLeaveDate) {
      return {
        disabled: true,
        style: {
          color: "white",
          backgroundColor: "var(--primary-color)",
          cursor: "not-allowed",
        },
      };
    }
    
    return {};
  }}
/>



{filteredHolidayList.length > 0 && (
      <div className="row calender-display d-md-flex d-sm-block">
        {filteredHolidayList.map((leave) => {
          const formattedDate = moment(leave.leaveOf, "DD-MM-YYYY").format("DD-MM-YY");
          return (
            <div className="col-2 text-nowrap leave-div-btn" key={leave.leaveId}>
              <button className="btn btn-danger me-2">
                <span className="d-flex align-items-center">
                  {formattedDate}
                  <i
                    className="ri-close-line ms-2"
                    onClick={() => handleDeleteLeave(leave.leaveId)}
                  ></i>
                </span>
              </button>
            </div>
          );
        })}
      </div>
    )}

            {clicked && (
                <div className="mb-3">
                    <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        value={leaveReason}
                        placeholder={t("leaveDetails")}
                        onChange={(e) => setLeaveReason(e.target.value)} 
                    />
                </div>
            )}
        </div>
    }
/>
          ) : null}

          {isSetAsWorkingDay ? (
            <AppDialog
              setVisibility={(e) => {
                setIsSetAsWorkingDay(e);
              }}
              widthType={utils.constants.dialogWidthType.small}
              dialogTitle={t("labelLeave")}
              dialogNegativeBtnText={t("noBtn")}
              dialogPositiveBtnText={t("yesBtn")}
              dialogNegativeBtnCall={() => {
                setIsSetAsWorkingDay(false);
              }}
              dialogPositiveBtnCall={() => {
                // setAsClinicWorkingDay(selectedLeaveId);
              }}
              view={
                <Component.WarningPop iconClassName="ri-delete-bin-line" warningMsg={t("setAsWorking")} />
              }
            />
          ) : null}
          <div>
            <div className="d-flex">
              <div className="screen-name flex-grow-1 mt-2">
                {t("clinicProfile")}
              </div>
              {isDoctorLogin === "false" && (
                <>
                  <div className="d-grid gap-2 d-md-flex justify-content-md-end more-details-clinic-profile profile-btn">
                    <div className="dropdown more-details-clinic-profile">
                      <button className="dropbtn">
                        <i className="ri-more-2-line"></i>
                      </button>
                      <div className="dropdown-content">
                        <a
                          onClick={() => {
                            setEditClinicProfile(true);
                          }}
                        >
                          {utils.constants.clinicProfileEditList[0].label}
                        </a>
                        <a
                          onClick={() => {
                            setPopup(!popup);
                          }}
                        >
                          {t("labelManageLeave")}
                        </a>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-outline-danger leave manage-leave mr-2"
                    >
                      <div className="d-md-flex">
                        <i className="ri-calendar-check-line me-1"></i>
                        <span
                          className="leave"
                          onClick={() => {
                            setPopup(!popup);
                          }}
                        >
                          {t("labelManageLeave")}
                        </span>
                      </div>
                    </button>
                  </div>
                  <OffCanvas
                    show={editClinicProfile}
                    onHide={handleClinicProfileCanvasChanges}
                    title={utils.constants.clinicProfileEditList[0].label}
                  >
                    <ClinicProfile
                      clinicProfileCanvas={handleClinicProfileCanvasChanges}
                      isEdited={handleClinicProfileUpdate}
                      hospitalDetails={clinicDetails}
                    />
                  </OffCanvas>
                  <div className="manage-leave">
                    <EditProfileDropdown
                      isEdited={handleClinicProfileUpdate}
                      isEditedConfigure={handleClinicConfigurationUpdate}
                      isEditClinicTiming={handleEditClinicTimingUpdate}
                      clinicDetails={clinicDetails}
                      refreshClinic={() => {
                        initFun();
                        refreshHeader();
                      }}
                      hospitalDetails={clinicDetails}
                      refreshProfile={getClinicProfile}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="view-clinic">
              <div className="row view-clinic-profile">
                <div className="clinic-profile-resp col-sm-12 col-md-5  col-lg-4 mt-2">
                  <ViewClinicProfileCard hospitalDetails={clinicDetails}/>
                </div>
                <div className="clinic-profile-resp col-sm-12 col-md-7 col-lg-8 view-details mt-2 ">
                  <ViewClinicProfileDetails randomRefresher={randomRefresherNumber} hospitalDetails={clinicDetails} holidayListprev={holidayList}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ViewClinicProfile;
